import { generatePath } from 'react-router'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'



import { IMAGE_SIZES, URL_PAGE_CATALOG_1ST_LVL } from '@shared/contants'
import { Product, useCategoryQuery, useProductsPreviewCardQuery } from '@shared/generated'

type CategoryProductsCarouselProps = {
  categoryId?: string;
}

export default function ProductsCategoryCarousel ({
  categoryId
}: CategoryProductsCarouselProps) {
  const { shopId } = useAddressStore()
  
  const { data: categoryData, loading: loadingCategory } = useCategoryQuery({
    variables: {
      categoryId: categoryId,
      shopId
    },
    skip: !categoryId
  })
  
  const { data, loading } = useProductsPreviewCardQuery({
    variables: {
      shopId,
      categoryId,
      pager: {
        limit: 20
      },
      style: IMAGE_SIZES.LARGE,
    }
  })

  const products = data?.products?.edges as Product[] ?? []

  const categoryLink = generatePath(URL_PAGE_CATALOG_1ST_LVL, {
    categorySlug: categoryData?.category?.slug ?? ''
  })

  return (
    <ProductCarousel
      link={categoryLink}
      title={categoryData?.category?.name ?? ''}
      products={products}
      loading={loading || loadingCategory}
    />
  )
}